(function () {
  var STORAGE_KEY = 'cart_countdown_end';
  var DURATION_MS = 10 * 60 * 1000; // 10 minutes

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function startCountdown() {
    var timerEl = document.getElementById('cart-timer');
    if (!timerEl) return;

    var endTime = sessionStorage.getItem(STORAGE_KEY);
    var now = Date.now();

    if (!endTime || parseInt(endTime, 10) <= now) {
      endTime = now + DURATION_MS;
      sessionStorage.setItem(STORAGE_KEY, endTime);
    } else {
      endTime = parseInt(endTime, 10);
    }

    function tick() {
      var remaining = endTime - Date.now();
      if (remaining <= 0) {
        timerEl.textContent = '00:00';
        sessionStorage.removeItem(STORAGE_KEY);
        return;
      }
      var minutes = Math.floor(remaining / 60000);
      var seconds = Math.floor((remaining % 60000) / 1000);
      timerEl.textContent = pad(minutes) + ':' + pad(seconds);
      setTimeout(tick, 1000);
    }

    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCountdown);
  } else {
    startCountdown();
  }
})();
